import { useLoading } from '../context/loadingContext.js';

const LoadingOverlay = () => {
  const { isLoading } = useLoading();

  if (!isLoading) return null;

  return (
    <div style={overlayStyle}>
      <div style={containerStyle}>
        <div style={spinnerStyle}></div>
        <span style={textStyle}>Carregando...</span>
      </div>
    </div>
  );
};

const overlayStyle = {
  position: 'fixed',
  top: 0, left: 0, right: 0, bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 9999
};

const containerStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};

const spinnerStyle = {
  width: '60px',
  height: '60px',
  border: '6px solid #f3f3f3',
  borderTop: '6px solid #C7D329',
  borderRadius: '50%',
  animation: 'spin 1s linear infinite',
};

const textStyle = {
  marginTop: '15px',
  color: '#fff',
  fontSize: '18px',
  fontFamily: 'sans-serif',
};

// Injetar a keyframe globalmente uma vez
const styleTag = document.createElement('style');
styleTag.innerHTML = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
document.head.appendChild(styleTag);

export default LoadingOverlay;
